import React, { useState } from 'react';
import { useWorkflowContext } from 'app/editor/workflow/context';
import { Box, Button, Input, Stack, Tab, Tabs } from '@mui/material';
import { workflowAPI } from 'api/workflow';
import useBundleTranslation from 'i18n';
import { type Node } from '@xyflow/react';

import JsonField from '../items/components/JsonField';

export default function ItemWrapper({ children }: { children: any }) {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);
    const { workflowId, nodes, edges, currentRun, refetchCurrentRun, setNodes, selectedItem } = useWorkflowContext();
    const [currentTab, setCurrentTab] = React.useState<string>('settings');
    let runId = currentRun ? currentRun.generic_workflow_run_id : 0;

    let runItemState =
        currentRun && currentRun.items && selectedItem && currentRun.items[selectedItem]
            ? currentRun.items[selectedItem]
            : null;

    let currentInput: { [key: string]: any } = {};
    edges.forEach((edge) => {
        if (edge.target == selectedItem && currentRun?.items?.[edge.source]) {
            let tmp = JSON.parse(currentRun.items[edge.source].output_data);
            if (tmp) {
                for (const nodesKey in nodes) {
                    if (nodes[nodesKey]['id'] == edge.source) {
                        let label: string = (nodes[nodesKey].data?.label as string) ?? '';
                        currentInput[label] = tmp;
                    }
                }
            }
        }
    });

    const currentInputText = JSON.stringify(currentInput);

    const node: Node | undefined = nodes.find((node) => node.id == selectedItem);

    if (!node) {
        return null;
    }

    const runItem = () => {
        workflowAPI.runItem(workflowId, runId, selectedItem ?? '', {}).then((data) => refetchCurrentRun());
    };

    const closeCurrentRun = () => {
        workflowAPI.closeCurrentRun(workflowId, runId).then((data) => refetchCurrentRun());
    };

    let outputData = runItemState && runItemState.output_data;

    const updateLabel = (label: any) => {
        let newNode = { ...node, data: { ...node.data, label: label } };
        setNodes(nodes.map((nd: Node) => (nd.id == selectedItem ? newNode : nd)));
    };

    return (
        <Stack spacing={2}>
            <Box>
                <Input
                    style={{ width: '100%' }}
                    type={'textarea'}
                    onChange={(event) => {
                        updateLabel(event.target.value);
                    }}
                    value={node?.data?.label ?? ''}
                />
            </Box>
            <Stack spacing={1} direction="row">
                <Button variant="contained" onClick={() => runItem()}>
                    {t('run')}
                </Button>
                {currentRun && runId > 0 && (
                    <Button variant="contained" onClick={() => closeCurrentRun()}>
                        {t('close_current_run')}
                    </Button>
                )}
            </Stack>

            <Tabs
                onChange={(e: React.SyntheticEvent, v: string) => setCurrentTab(v)}
                value={currentTab}
                className={'form-tabs'}
                sx={{ flexGrow: 1, mb: '-1px' }}
            >
                <Tab className={'form-tab'} value={'settings'} label={t('settings')} />
                {currentInputText != '{}' && (
                    <Tab className={'form-tab'} value={'input_data'} label={t('input_data')} />
                )}
                {runItemState && runItemState.output_data > '' && (
                    <Tab className={'form-tab'} value={'output_data'} label={t('output_data')} />
                )}
            </Tabs>

            {'settings' == currentTab && <Box>{children}</Box>}
            {'input_data' == currentTab && (
                <Box>
                    <JsonField value={currentInputText} readOnly={true} />
                </Box>
            )}
            {'output_data' == currentTab && <Box>{runItemState && runItemState.output_data}</Box>}
        </Stack>
    );
}
